import React from "react";
import { connect } from "react-redux";

interface ICustomerIndexComponentProps extends React.HTMLProps<CustomerIndexComponent> {
}

export class CustomerIndexComponent extends React.Component<ICustomerIndexComponentProps, {}> {
  render() {
    return (
      <div>
        {this.props.children}
      </div>
    );
  }
}

const mapStateToProps = (state: IWebStoreState) => {
  return {
  }
}

export const CustomerIndex = connect(
  mapStateToProps,
)(CustomerIndexComponent)